// src/components/pwa/InstallBanner.js
import React, { useState } from 'react';
import { Download, X, Smartphone, Monitor } from 'lucide-react';
import { usePWAInstall } from '../../hooks/usePWAInstall';

const InstallBanner = () => {
  const { canInstall, installApp } = usePWAInstall();
  const [dismissed, setDismissed] = useState(
    localStorage.getItem('pwa-install-dismissed') === 'true'
  );

  const handleInstall = async () => {
    const success = await installApp();
    if (success) {
      setDismissed(true);
    }
  };

  const handleDismiss = () => {
    setDismissed(true);
    localStorage.setItem('pwa-install-dismissed', 'true');
  };

  if (!canInstall || dismissed) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 bg-blue-600 text-white rounded-lg shadow-lg p-4 mx-auto max-w-md">
      <div className="flex items-start space-x-3">
        <div className="flex-shrink-0">
          <Smartphone className="w-6 h-6" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-sm font-semibold">Installa l'App</h3>
          <p className="text-xs text-blue-100 mt-1">
            Accedi più velocemente e lavora anche offline
          </p>
          <div className="flex space-x-2 mt-3">
            <button
              onClick={handleInstall}
              className="flex items-center space-x-1 px-3 py-1 bg-white text-blue-600 rounded text-xs font-medium hover:bg-blue-50"
            >
              <Download className="w-3 h-3" />
              <span>Installa</span>
            </button>
            <button
              onClick={handleDismiss}
              className="px-3 py-1 text-blue-100 text-xs hover:text-white"
            >
              Non ora
            </button>
          </div>
        </div>
        <button
          onClick={handleDismiss}
          className="flex-shrink-0 text-blue-100 hover:text-white"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default InstallBanner;